"use client";
import React, { useEffect, useState } from "react"; 
import { useParams, Link } from "react-router-dom";
import Sidebar from '../home/Sidebar';
import { cleanTitle } from '../../utils/helpers';

export default function Home() {
  const { slug } = useParams(); 
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [artists, setArtists] = useState([]);
  const [organizers, setOrganizers] = useState([]);
  const [entry_options, setEntryOptions] = useState([]);
  const wpUrl = process.env.REACT_APP_WP_URL;
   const [selectedEvent, setSelectedEvent] = useState(null);
    const [isSidebar, setIsSidebar] = useState(false);
    const handleSidebar = (eventData) => {
          setSelectedEvent(eventData);
          setIsSidebar(!isSidebar);
      }
useEffect(() => {
  
  const fetchEvent = async () => {
    try {
      // Get the post by slug (with embedded terms)
      const response = await fetch(`${wpUrl}wp-json/wp/v2/posts?slug=${slug}&_embed`);
      const data = await response.json();
      const eventData = data[0];
      
      setEvent(eventData);

      //const artistsRaw = eventData.acf?.artist || ""; 
      const artistsRaw = eventData.artist || "";
     
      const parsedArtists = artistsRaw.split(",").map(name => name.trim());
      setArtists(parsedArtists);  

       const organizersRaw = eventData.organizer || "";
     
      const parsedOrganizers = organizersRaw.split(",").map(name => name.trim());
      setOrganizers(parsedOrganizers);  


      const attachedCategories = eventData._embedded?.['wp:term']?.[0] || [];
    
         // Filter only 'entry-options' terms
        const entryOptionsTerms = attachedCategories.filter(term => {
          return term.link.includes('/category/entry-options/');
        });

      
        const entry_options = entryOptionsTerms.filter(term => term.parent !== 0);
        setEntryOptions(entry_options);  

        
         
    const [venueRes, genreRes, eventtypeRes] = await Promise.all([
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=venue-type`),
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=genre`),
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=event-type`)
      ]);

      const [venueData, genreData, eventtypeData] = await Promise.all([
        venueRes.json(),
        genreRes.json(),
        eventtypeRes.json(),
      ]);

      const venueCat = venueData[0];
      const genreCat = genreData[0];
      const eventtypeCat = eventtypeData[0];

     
      if (!venueCat && !genreCat && !eventtypeCat) {
        console.warn("No matching parent categories found.");
        return;
      }


      // Fetch all subcategories of venue-type and genre
      const subcatFetches = [];
     
        if (venueCat) {
          subcatFetches.push({
            type: 'venue_type',
            promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${venueCat.id}`)
          });
        }

        if (genreCat) {
          subcatFetches.push({
            type: 'genre',
            promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${genreCat.id}`)
          });
        }

        if (eventtypeCat) {
          subcatFetches.push({
            type: 'event_type',
            promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${eventtypeCat.id}`)
          });
        }


  
      const subcatDataArrays = await Promise.all(
        subcatFetches.map(async obj => ({
          type: obj.type,
          data: await (await obj.promise).json()
        }))
      );

      // Flatten into subcategories, tagging each with its type
      const allSubcategories = subcatDataArrays.flatMap(obj =>
        obj.data.map(sub => ({ ...sub, type: obj.type }))
      );

      // Match attached categories and keep the `type`
      const matchedSubCategories = attachedCategories
        .map(attached => {
          const match = allSubcategories.find(sub => sub.id === attached.id);
          return match ? { ...attached, type: match.type } : null;
        })
        .filter(Boolean); // remove nulls

  
          // Set to state
      setCategories(matchedSubCategories);


    } catch (error) {
      console.error("Error fetching event or venue type:", error);
    } finally {
      setLoading(false);
    }


  };

  fetchEvent();
}, [slug]);

    
    if (loading) return <p>Loading...</p>;
    if (!event) return <p>Event not found</p>;

    const eventTypeSlug = categories.find(cat => cat.type === 'event_type')?.slug || 'event';
    // Map slug to Schema.org @type
    const getSchemaType = (slug) => {
      switch (slug.toLowerCase()) {
        case "festival":
          return "Festival";
        case "nightclub":
        case "club":
        case "night-life":
        case "night_life":
          return "DanceEvent";
        case "music":
        case "concert":
          return "MusicEvent";
        case "sports":
          return "SportsEvent";
        case "theater":
        case "theatre":
          return "TheaterEvent";
        default:
          return "Event";
      }
    };

    const schemaType = getSchemaType(eventTypeSlug);
  const startDate = event.date ? new Date(event.date).toISOString() : null;
  const endDate = event.end_date ? new Date(event.end_date).toISOString() : startDate;
     
   let schema = null;

      if (schemaType === 'Festival') {
        schema = {
          "@context": "https://schema.org",
          "@type": "Festival",
          "name": cleanTitle(event.title.rendered),
          "startDate": startDate,
          "endDate": endDate,
          "eventStatus": "https://schema.org/EventScheduled",
          "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
          "location": {
            "@type": "Place",
            "name": event.venue,
            "address": {
              "@type": "PostalAddress",
              "addressLocality": event.city,
              "addressRegion": event.state,
              "addressCountry": event.country
            }
          },
          "image": event._embedded?.['wp:featuredmedia']?.[0]?.source_url,
          "description": event.excerpt?.rendered || "",
          "performer": artists.map(name => ({
            "@type": "PerformingGroup",
            "name": name
          })),
          "organizer": organizers.length > 0
            ? {
                "@type": "Organization",
                "name": typeof organizers[0] === "object" ? organizers[0].name : organizers[0]
              }
            : undefined,
          "eventSchedule": event.long_date
            ? {
                "@type": "Schedule",
                "startDate": startDate,
                "endDate": endDate,
                "repeatFrequency": "P1D"
              }
            : undefined
        };
      } else {
        schema = {
          "@context": "https://schema.org",
          "@type": "MusicEvent",
          "name": cleanTitle(event.title.rendered),
          "startDate": startDate,
          "endDate": endDate,
          "eventStatus": "https://schema.org/EventScheduled",
          "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
          "location": {
            "@type": "Place",
            "name": event.venue,
            "address": {
              "@type": "PostalAddress",
              "addressLocality": event.city,
              "addressRegion": event.state,
              "postalCode": event.zip,
              "addressCountry": event.country
            }
          },
          "image": event._embedded?.['wp:featuredmedia']?.[0]?.source_url,
          "description": event.excerpt?.rendered?.replace(/(<([^>]+)>)/gi, "") || "",
          "performer": artists.map(name => ({
            "@type": "MusicGroup",
            "name": name
          })),
          "organizer": organizers.length > 0
            ? {
                "@type": "Organization",
                "name": typeof organizers[0] === "object" ? organizers[0].name : organizers[0]
              }
            : {
                "@type": "Organization",
                "name": "Unknown Organizer"
              }
        };
      }

  return (
    <>
     
        {schema && (
             <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
          )}
        {/*Blog Details Start*/}
        <section className="event-details">
          <div className="container">
            <div className="row">
              <div className="col-xl-8 col-lg-7">
                <div className="event-details__left">
                  <div className="event-details__img">
                    <img
                        src={event._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                        alt={cleanTitle(event.title.rendered)}
                        style={{ width: '100%', height: 'auto' }}
                        />
                  </div>
                   <div className="event-details__main-tab-box tabs-box">

                          <ul className="tab-buttons clearfix list-unstyled">
                            {categories.map(cat => {
                              let link = '/event';
                              if (cat.type === 'venue_type') {
                                link += `?venue_type=${encodeURIComponent(cat.slug || '')}`;
                              } else if (cat.type === 'genre') {
                                link += `?genre=${encodeURIComponent(cat.slug || '')}`;
                              } else if (cat.type === 'event_type') {
                                link += `?event_type=${encodeURIComponent(cat.slug || '')}`;
                              }

                              return (
                                <Link key={cat.id} to={link}>
                                  <li className="tab-btn" >
                                    <p>{cat.name}</p>
                                  </li>
                                </Link>
                              );
                            })}
                          </ul>
                  </div>
                  <div className="event-details__tab-content-box">
                      <ul className="event-details__meta list-unstyled">
                        <li>
                          <p>
                            <span className="icon-clock"></span>
                             { event.long_date}
                          </p>
                        </li>
                        <li>
                          <p>
                            <span className="icon-pin"></span>
                              { event.venue} 
                          </p>
                        </li>
                      </ul>
                      <h3 className="event-details__title-1">
                        { cleanTitle(event.title.rendered)}
                      </h3>
                      {/* <p className="event-details__text-1">
                        {event.content.rendered}
                      </p> */}
                    <div
                      className="event-details__text-1"
                      dangerouslySetInnerHTML={{ __html: event.content.rendered }}
                    />
                  
                    </div>
                  <div className="event-details__main-tab-box tabs-box">
                  
                    <div className="tabs-content">
                    
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-5">
                <div className="event-details__right">
                 {(event.promo_code) && (
                    <div className="event-details__speakers">
                      <h3 className="event-details__speakers-title text-center">Promo Code</h3>

                      {event.promo_code && (
                        <p className="event-details__speakers-sub-title">
                          <i className="fas fa-tags"></i> Promo Code: {event.promo_code}
                        </p>
                      )}

                      {event.promo_text && (
                        <p className="event-details__speakers-text">
                          {event.promo_text}
                        </p>
                      )}
                    </div>
                  )}
                  
                  <div className="event-details__ticket">
                    <h3 className="event-details__ticket-title">
                    Need a Ride?
                    </h3>
                    <p className="event-details__ticket-sub-title">
                      Call Us Now
                    </p>
                    <div className="event-details__ticket-icon">
                      <span className="icon-call"></span>
                    </div>
                    <p className="event-details__ticket-sub-title-2">
                      For Limo or Party Bus Service
                    </p>
                    <h3 className="event-details__ticket-number">
                      <Link to="tel:7754874400">775 487 4400</Link>
                    </h3>
                  </div>


                   <div className="event-details__ticket">
                    <h3 className="event-details__ticket-title">
                    Artist Line Up
                    </h3>
                        <div className="event-details__main-tab-box tabs-box">
                          <ul className="tab-buttons clearfix list-unstyled">
                            {artists.map((artist, index) => (
                            <Link key={index} to={`/event?artist=${encodeURIComponent(artist.slug || artist)}`}><li 
                              className='tab-btn'>
                              <p>{artist}</p>
                            </li></Link>
                            ))}
                        </ul>
                        </div>
                  </div>
                        
                 {organizers && organizers.length > 0 && (
                  <div className="event-details__ticket">
                    <h3 className="event-details__ticket-title">
                      Organizers
                    </h3>
                    <div className="event-details__main-tab-box tabs-box">
                      <ul className="tab-buttons clearfix list-unstyled">
                        {organizers.map((organizer, index) => (
                          <Link key={index} to={`/event?organizer=${encodeURIComponent(organizer.slug || organizer)}`}>
                            <li className='tab-btn'>
                              <p>{organizer.name || organizer}</p>
                            </li>
                          </Link>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                 {entry_options && entry_options.length > 0 && (
                  <div className="event-details__ticket-two">
                    <h3 className="event-details__ticket-two-title">
                      Entry Options
                    </h3>
                    <br />
                    <ul className="footer-widget__contact-list list-unstyled">
                      {entry_options.map((entry_option) => (
                        <li key={entry_option.id}>
                          <div className="icon">
                            <span className="icon-star"></span>
                          </div>
                          <div className="text">
                            <Link
                              className="text-white"
                              to={`/event?entry_option=${encodeURIComponent(entry_option.slug || entry_option.name)}`}
                            >
                              {entry_option.name}
                            </Link>

                            {entry_option.name === 'Tickets' && event.ticket_link && (
                              <a
                                href={event.ticket_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-2"
                              >
                                Buy Tickets Here
                              </a>
                            )}

                            {entry_option.name === 'VIP Tables' && (
                              <a
                                onClick={() => handleSidebar(event)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-2"
                              >
                                Request Table
                              </a>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                  <div className="event-details__location">
                    <h3 className="event-details__location-title">Location</h3>
                    <p className="event-details__ticket-sub-title">
                       <span className="icon-pin"></span> { event.venue} 
                    </p>
                 
                    {event.google_maps && (
                      <iframe
                        src={event.google_maps}
                        className="google-map__one"
                        allowFullScreen
                        title="Event Location"
                      ></iframe>
                    )}
                  </div>
                
                 
                </div>
              </div>
            </div>
          </div>
        </section>
         <Sidebar isSidebar={isSidebar} 
            handleSidebar={() => setIsSidebar(false)}
            event={selectedEvent} />
        {/*Blog Details End*/}
    </>
  );
}
